import { FileInput, type InputProps } from "@mantine/core";

import ImageUploader from "../../components/shared/ImageUploader/ImageUploader";
import { useInputProps } from "../hooks/useInputProps";
import { readFileData } from "../../components/shared/ImageUploader/pdf.utils";

interface IImageInput extends InputProps {
  value: string;
  id: string;
  required?: boolean;
}

const ImageInput = ({ value: defaultValue, id, required }: IImageInput) => {
  const { value, setValue } = useInputProps(id, defaultValue, required);

  const handleChange = async (image: File) => {
    const data = await readFileData(image);
    setValue(id, data);
  };
  const isValid = typeof value === "string" && value.length > 0;
  const isPdf = isValid && value.includes("application/pdf");
  const isImage = isValid && value.includes("data:image");
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
      {isPdf && (
        <iframe
          className="image-wrap-pdf"
          src={value}
          width="300"
          height="300"></iframe>
      )}
      {isImage && <img src={value} alt="uploaded" width="300" />}
      <FileInput
        onChange={handleChange}
        label="Select file to upload"
        accept="image/*, application/pdf"
        style={!isImage && !isPdf ? { margin: "0 auto" } : undefined}
      />
    </div>
  );
};
export default ImageInput;
